import { paths } from '@common/types';
import { axiosInstance } from '@config/axios/axios.config';
import { useMutation } from '@tanstack/react-query';

const sendBridgetMessageRequest = async ({
  ...props
}: paths['/bridget']['post']['requestBody']['content']['application/json']) => {
  const response = axiosInstance.post<
    paths['/bridget']['post']['responses']['200']['content']['application/json']
  >(`/bridget`, {
    ...props,
  });
  const data = await response;

  return data;
};

export const useSendBridgetMessageMutation = () => {
  const mutation = useMutation({
    mutationKey: ['sendBridgetMessage'],
    mutationFn: (
      props: paths['/bridget']['post']['requestBody']['content']['application/json'],
    ) => sendBridgetMessageRequest({ ...props }),
  });

  return mutation;
};
